import { styled } from "@mui/material";
import { getProfileQuestionnaireItemWrapperPadding } from "../utils/get-profile-questionnaire-item-wrapper-padding.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
const ProfileQuestionnaireItemWrapper = styled("div", styledOptions)((args) => {
  const padding = getProfileQuestionnaireItemWrapperPadding(args);
  return {
    width: "100%",
    padding
  };
});
export {
  ProfileQuestionnaireItemWrapper
};
//# sourceMappingURL=profile-questionnaire-item-wrapper.es.js.map
